/* Base rate history "Download CSV": pure column map over the history entries (no maker email). */
import { csv_file_name } from '../../../util_components/csv_export/to_csv';
import { is_opening, status_view } from './logic';

export const BASE_RATE_CSV_COLUMNS = [
  { header: 'Entry ID', key: 'uuid' },
  { header: 'From (IST)', key: 'effective_from_ist', kind: 'date' },
  { header: 'Rate per 60 min', key: 'base_rate', kind: 'money' },
  { header: 'Status', value: (e) => status_view(e.status).label },
  { header: 'Note', value: (e) => (is_opening(e) ? 'Opening rate' : e.note || '') },
  { header: 'Source', key: 'source' },
  { header: 'Changed by', key: 'created_by_name' },
  { header: 'Changed at (IST)', key: 'created_at_ist', kind: 'datetime' }
];

export const base_rate_csv_name = (teacher_name) =>
  csv_file_name({ page: 'base-rate-history', table: teacher_name || 'teacher' });
